import React from 'react';
import { Card } from 'antd';
import {
    AimOutlined,
    RocketOutlined,
    SmileOutlined,
    TeamOutlined,
} from '@ant-design/icons';
import type { AnalyticsTabKey } from '~containers/analytics/overview-page/tabs';
import style from './style.module.scss';

interface SectionTile {
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    tabKey: AnalyticsTabKey;
}

const SECTION_TILES: SectionTile[] = [
    {
        icon: <TeamOutlined />,
        title: 'Acquisition & Activation',
        subtitle: 'Funnel, attribution, CPA',
        tabKey: 'acquisition',
    },
    {
        icon: <RocketOutlined />,
        title: 'Engagement & Usage',
        subtitle: 'MAU, affinity, sessions',
        tabKey: 'engagement',
    },
    {
        icon: <SmileOutlined />,
        title: 'Retention & Health',
        subtitle: 'Churn, reviews',
        tabKey: 'retention',
    },
    {
        icon: <AimOutlined />,
        title: 'Regional & Demographic',
        subtitle: 'Age, platform, age-gating',
        tabKey: 'demographic',
    },
];

const TileBody = ({ tile }: { tile: SectionTile }) => (
    <div className={style.tile_body}>
        <span className={style.tile_icon}>{tile.icon}</span>
        <div className={style.tile_text}>
            <span className={style.tile_title}>{tile.title}</span>
            <span className={style.tile_subtitle}>{tile.subtitle}</span>
        </div>
    </div>
);

/** The Overview "Sections" tiles: each calls `onSelect` with the deeper
 * analytics tab it names. */
export const SectionTiles = ({
    onSelect,
}: {
    onSelect: (tabKey: AnalyticsTabKey) => void;
}) => (
    <div className={style.section_tiles}>
        {SECTION_TILES.map((tile) => (
            <Card
                key={tile.title}
                className={style.tile}
                hoverable
                role="button"
                tabIndex={0}
                onClick={() => onSelect(tile.tabKey)}
                // antd's Card renders a div, so the keyboard activation
                // a real button gives for free has to be added here.
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onSelect(tile.tabKey);
                    }
                }}
            >
                <TileBody tile={tile} />
            </Card>
        ))}
    </div>
);
